var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-12 pt-3 px-0"},[_c('h2',{staticClass:"title-3 text-grey-900 w-100 pb-4"},[_vm._v(" "+_vm._s(_vm.content.station_whereIsLocated)+" ")]),_c('Map')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }